import cn from 'classnames';

import { IConDefaultType } from '../types';
export enum FollowerIconVariant {
  BUBBLETAP = 'bubbletap',
  CHAT = 'chat',
}
interface IFollowerIconProps extends IConDefaultType {
  variant?: FollowerIconVariant;
}

function FollowerIcon({
  variant = FollowerIconVariant.BUBBLETAP,
  className,
  size = 24,
  rotate,
  flip,
}: IFollowerIconProps) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      {variant === FollowerIconVariant.BUBBLETAP && (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.8552 11.6341C14.172 11.6341 16.0502 9.75588 16.0502 7.43899C16.0502 5.1221 14.172 3.2439 11.8552 3.2439C9.53827 3.2439 7.66006 5.1221 7.66006 7.43899C7.66006 9.75588 9.53827 11.6341 11.8552 11.6341ZM2.51463 19.4462C3.55088 15.7656 7.41809 13.0314 12.0303 13.0314C16.6426 13.0314 20.5098 15.7656 21.5461 19.4462C21.8454 20.5094 20.9235 21.4216 19.8189 21.4216H4.24179C3.13722 21.4216 2.21528 20.5094 2.51463 19.4462Z"
            fill="#ADB0B8"
          />
        </svg>
      )}
      {variant === FollowerIconVariant.CHAT && (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.00013 5.96953C7.46453 5.96953 8.65165 4.78241 8.65165 3.31802C8.65165 1.85363 7.46453 0.666504 6.00013 0.666504C4.53574 0.666504 3.34862 1.85363 3.34862 3.31802C3.34862 4.78241 4.53574 5.96953 6.00013 5.96953ZM0.718442 11.8031C0.961897 8.82986 3.23352 6.49984 5.99988 6.49984C8.76623 6.49984 11.0379 8.82986 11.2813 11.8031C11.3052 12.095 11.0655 12.3332 10.7726 12.3332H1.22715C0.93427 12.3332 0.694541 12.095 0.718442 11.8031Z"
            fill="white"
          />
        </svg>
      )}
    </i>
  );
}

export default FollowerIcon;
